import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import Proposal from "../../../state/proposal/Proposal"
import { QuoteDto } from "../../../state/quote/Quote"
import DocumentEventExportedComponent from "./DocumentEventExportedComponent"

type OwnProps = {
    object: EventObjectDto
    quote: QuoteDto
    proposal: Proposal
}

const QuoteExportedToHubspotEvent = (props: OwnProps) => {
    const Url = Integrations.getExternalOrderUrl(props.object)

    return <DocumentEventExportedComponent 
        url={Url}
        exportedMainMessage={<FormattedMessage
            id="quote.analytics.events.exported.hubspot.text"
            defaultMessage="Quote {identifier} was created from a Hubspot deal"
            values={{
                identifier: <strong>{props.quote.attributes.identifier}</strong>,
            }}
        />}
        buttonMessage={<FormattedMessage
            id="quote.analytics.events.exported.hubspot.open"
            defaultMessage="Open deal in HubSpot"
        />}
        integrationLogo={{
            integrationKey: INTEGRATION_KEY.HUBSPOT,
            width: 100,
            height: 30,
        }}
    />
}


export default QuoteExportedToHubspotEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-exported-hubspot.component.tsx